import { render } from "./NavSection.vue?vue&type=template&id=4009fa6e"
import script from "./NavSection.vue?vue&type=script&lang=js"
export * from "./NavSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__